// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3LpPf","title":"AfterBackImages_title__MSeYk","images":"AfterBackImages_images__K1hF-"};